export default __webpack_public_path__ + "static/media/barcode.c3157cbc.svg";